import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../services/date/date.service';

@Pipe({ name: 'reduceTimeString',pure:false })
export class ReduceTimeStringPipe implements PipeTransform {
  constructor(private dateService:DateService){

  }
  transform(time: any) {
    return this.dateService.reduceTimeString(time);
  }
}